import { render, staticRenderFns } from "./carrierTable.vue?vue&type=template&id=98f361d8&"
import script from "./carrierTable.vue?vue&type=script&lang=js&"
export * from "./carrierTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports